const __WEBPACK_NAMESPACE_OBJECT__ = require("core-js/modules/es.typed-array.map.js");